import React from 'react';
import styled from 'styled-components';
import { blue60, blue80, blue100 } from '@zocdoc-mezzanine/foundations-colors';
import Link from './private/BaseLink';

/**
 * InlineLink
 * Links that are embedded within a body of text. This component should be wrapped with the parent
 * text to inherit the same size as the surrounding text.
 *
 * @param {LinkProps} props - props for link
 * @returns {JSX.Element} InlineLink
 */
function InlineLink({
    href,
    children,
    onClick,
    beforeClick,
    target,
    rel,
    title,
    tabIndex,
    'data-test': dataTest,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledby,
    'aria-describedby': ariaDescribedby,
}) {
    return (
        <StyledInlineLink
            href={href}
            children={children}
            onClick={onClick}
            beforeClick={beforeClick}
            target={target}
            rel={rel}
            title={title}
            tabIndex={tabIndex}
            data-test={dataTest}
            aria-label={ariaLabel}
            aria-labelledby={ariaLabelledby}
            aria-describedby={ariaDescribedby}
        />
    );
}

const StyledInlineLink = styled(Link)`
    color: ${blue100};
    text-decoration: underline;

    &:hover,
    &:active {
        color: ${blue80};
    }

    &:focus {
        text-decoration: none;
        border-radius: 2px;
        border: 1px solid ${blue60};
    }
`;

export default InlineLink;
